import { certificateControlActions } from '../actions'

const {
  FETCHING_CERTIFICATE_CONTROLS,
  FETCH_CERTIFICATE_CONTROLS,
  FETCH_CERTIFICATE_CONTROLS_ERROR,

} = certificateControlActions

const initialState = {
  fetching: {
    // download: false,
    // certificateControl: false,
    certificateControls: false
  },
  items: [],
  last_update: undefined,
  total_records: undefined,
  fetch_errors: {
    // donwload: false,
    // productMap: false,
    certificateControls: false
  }
}

const certificateControl = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_CERTIFICATE_CONTROLS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          certificateControls: action.value
        }
      }

    case FETCH_CERTIFICATE_CONTROLS:
      return {
        ...state,
        last_update: action.last_update,
        total_records: action.total_records,
        items: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          certificateControls: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          certificateControls: false
        }
      }

    case FETCH_CERTIFICATE_CONTROLS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMaps: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          productMaps: true
        }
      }

    default:
      return state
  }
}

export default certificateControl



// WEBPACK FOOTER //
// ./src/reducers/certificateControl.js